/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { Container, Responsive, Grid } from 'vendors/semantic-ui';

import { configUI } from 'config';

import { useRouter } from 'modules/shared/hooks';
import { Menu, Logo, ContextualMenu } from 'modules/shared/components';

import { HeaderProps } from './header-type';

import styles from './header-component.module.css';

export const Header: React.FC<HeaderProps> = React.memo(({ title, children, menuItems }: HeaderProps) => {
    const rootElement = document.getElementById('root');

    const [visible, setVisible] = useState(false);

    const { history } = useRouter();

    const toggleSideNav: () => void = () => {
        setVisible(!visible);
    };

    useEffect(() => {
        if (rootElement) {
            rootElement.className = styles.personalSpaceRoot;
        }
        return () => {
            if (rootElement) {
                rootElement.className = '';
            }
        };
    });

    useEffect(() => {
        setVisible(false);
    }, [history.location.pathname]);

    return (
        <React.Fragment>
            {title && (
                <div className={`elementToPrintOnly ${styles['print-header']}`}>
                    <h1>{title}</h1>
                </div>
            )}
            <div className={`${styles.root} elementNotToPrint`}>
                <header className={`${styles.header} ui fixed`}>
                    <Container id={styles.headerContainer} fluid className={styles.headerContainer}>
                        <Grid className={styles.grid}>
                            <Grid.Row columns={3} className={styles['top-row']}>
                                <Grid.Column className={`${styles.outsideColumn} ${styles.leftColumn}`}>
                                    {menuItems && menuItems.length > 0 && (
                                        <Responsive as={React.Fragment} maxWidth={configUI.responsive.tablet.maxWidth}>
                                            <button
                                                type="button"
                                                className={`${styles.menuBtn} ${visible ? styles.active : ''}`}
                                                onClick={toggleSideNav}
                                            />
                                        </Responsive>
                                    )}
                                    <Responsive as={React.Fragment} minWidth={configUI.responsive.computer.minWidth}>
                                        <div className={styles.leftColumn}>
                                            <Logo maxWidth={150} maxHeight={35} noMargin alignLeft />
                                        </div>
                                    </Responsive>
                                </Grid.Column>
                                <Grid.Column>
                                    <Responsive as={React.Fragment} maxWidth={configUI.responsive.tablet.maxWidth}>
                                        <div className={styles.centerColumn}>
                                            <Logo maxWidth={150} noMargin />
                                        </div>
                                    </Responsive>
                                </Grid.Column>
                                <Grid.Column className={`${styles.outsideColumn} ${styles.rightColumn}`}>
                                    <div className={styles.contextualMenuContainer}>
                                        <ContextualMenu />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={1} className={styles['detail-row']}>
                                <Grid.Column>{children}</Grid.Column>
                            </Grid.Row>
                            <Responsive minWidth={configUI.responsive.computer.minWidth} as={React.Fragment}>
                                <Grid.Row columns={1} className={styles['nav-row']}>
                                    <Grid.Column className={styles['no-vetical-margin']}>
                                        {menuItems && <Menu elements={menuItems} top={195} verticalDisplay />}
                                    </Grid.Column>
                                </Grid.Row>
                            </Responsive>
                        </Grid>
                    </Container>
                </header>

                <Responsive maxWidth={configUI.responsive.tablet.maxWidth}>
                    {menuItems && <Menu elements={menuItems} top={140} visible={visible} />}
                </Responsive>
                <Responsive maxWidth={configUI.responsive.mobile.maxWidth}>
                    {menuItems && <Menu elements={menuItems} top={170} visible={visible} />}
                </Responsive>
            </div>
        </React.Fragment>
    );
});
